import styles from './EmptyDataset.module.scss'
import { ScoopColumn, ScoopText, ScoopButton } from '../ui'
import { PlusIcon } from '@phosphor-icons/react'

export const EmptyDataset = ({
    title,
    description,
    icon,
    iconComponent,
    onClick,
    buttonText = 'Create your first dataset',
    hideButton = false,
    showButtonIcon = true,
}) => {
    return (
        <ScoopColumn className={styles.container}>
            {iconComponent ? (
                iconComponent
            ) : (
                <div className={styles.iconContainer}>
                    <img src={icon} alt="Empty dataset" className={styles.iconImage} />
                </div>
            )}
            <ScoopColumn className={styles.textContainer}>
                <ScoopText className={styles.title}>{title}</ScoopText>
                <ScoopText className={styles.description}>{description}</ScoopText>
            </ScoopColumn>
            {!hideButton && (
                <ScoopButton
                    size="sm"
                    className={`${styles.button}`}
                    onClick={onClick}
                    leftSection={
                        showButtonIcon && <PlusIcon size={16} className={styles.iconWhite} />
                    }
                >
                    {buttonText}
                </ScoopButton>
            )}
        </ScoopColumn>
    )
}
